import { useFlippers } from "../useFlippers/useFlippers";
import { useSharedGlobalConfig } from "../useSharedGlobalConfig/useSharedGlobalConfig";

const useStripeAdditionalInfo = (): Boolean => {
  const { isCanada } = useSharedGlobalConfig();
  const [stripeAdditionalInfoEnabled] = useFlippers("stripe_additional_info");

  return isCanada && stripeAdditionalInfoEnabled;
};

export { useStripeAdditionalInfo };
